/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from 'styled-components';
import { Tabs } from 'antd';

export const PageWrapper = styled.div`
  // min-height: calc(100vh - 100px);
  padding: 16px;
  background: #ffffff;

  .survey-comment-list {
    padding: 8px;

    .survey-comment-item {
      padding: 2px 6px;
      margin-top: 4px;
      color: #757575;
      border: solid 1px #dddddd;
      border-radius: 4px;
    }
  }

  .default-button-style {
    width: 200px;
    height: 40px;
    border-radius: 5px;
  }
`;

export const ContentWrapper = styled.div`
  background: #fff;
  min-height: calc(100vh - 150px);

  .button-group {
    display: flex;
    justify-content: end;
    gap: 16px;
    margin: 0px 16px 16px;

    button {
      height: 40px;
      font-size: 14px;
      border-radius: 5px;
    }
  }
`;

export const CategoryWrapper = styled.div`
  .caregory-name {
    display: flex;
    align-items: center;
    width: 100%;
    height: 54px;
    padding: 0px 20px;
    background: #f8f8f8;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-size: 18px;
    font-weight: 700;

    .menu-count {
      padding-left: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #666;
    }
  }
`;

export const StyledTabs = styled(Tabs)`
  & .ant-tabs-nav-wrap .ant-tabs-nav-list {
    width: 100%;

    .ant-tabs-tab {
      justify-content: center;
      width: 100%;
      margin: 0;
    }
    .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
      width: 100%;
    }
  }
  & .ant-tabs-nav .ant-tabs-nav-operations {
    display: none;
  }
`;
